import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "content",
  class: "section bg-transparent my-0 py-0"
}
const _hoisted_2 = {
  class: "content-wrap pt-5",
  style: {"overflow":"visible"}
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row border-between" }
const _hoisted_5 = { class: "col-lg-5" }
const _hoisted_6 = { class: "row posts-md col-mb-30" }
const _hoisted_7 = {
  key: 1,
  id: "content",
  class: "section bg-transparent my-0 py-0"
}
const _hoisted_8 = {
  class: "content-wrap pt-5",
  style: {"overflow":"visible"}
}
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "row border-between" }
const _hoisted_11 = { class: "col-lg-7 mb-5 mb-lg-0" }
const _hoisted_12 = { class: "entry border-bottom-0 mb-0" }
const _hoisted_13 = { class: "entry-image" }
const _hoisted_14 = ["href"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "entry-title" }
const _hoisted_17 = { class: "entry-categories" }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "entry-meta" }
const _hoisted_21 = { href: "#" }
const _hoisted_22 = { class: "entry-content" }
const _hoisted_23 = { class: "col-lg-5" }
const _hoisted_24 = { class: "row posts-md col-mb-30" }
const _hoisted_25 = { class: "grid-inner row gutter-20" }
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = ["href"]
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "col-md-8" }
const _hoisted_30 = { class: "entry-title title-xs" }
const _hoisted_31 = { class: "entry-categories" }
const _hoisted_32 = ["href"]
const _hoisted_33 = ["href"]
const _hoisted_34 = { class: "entry-meta" }
const _hoisted_35 = { href: "#" }
const _hoisted_36 = {
  key: 2,
  id: "content",
  class: "section dark my-0 py-0"
}
const _hoisted_37 = {
  class: "content-wrap pt-5",
  style: {"overflow":"visible"}
}
const _hoisted_38 = { class: "container" }
const _hoisted_39 = { class: "row border-between" }
const _hoisted_40 = { class: "col-lg-5" }
const _hoisted_41 = { class: "row posts-md col-mb-30" }
const _hoisted_42 = {
  key: 3,
  id: "content",
  class: "section dark my-0 py-0"
}
const _hoisted_43 = {
  class: "content-wrap pt-5",
  style: {"overflow":"visible"}
}
const _hoisted_44 = { class: "container" }
const _hoisted_45 = { class: "row border-between" }
const _hoisted_46 = { class: "col-lg-7 mb-5 mb-lg-0" }
const _hoisted_47 = { class: "entry border-bottom-0 mb-0" }
const _hoisted_48 = { class: "entry-image" }
const _hoisted_49 = ["href"]
const _hoisted_50 = ["src"]
const _hoisted_51 = { class: "entry-title" }
const _hoisted_52 = { class: "entry-categories" }
const _hoisted_53 = ["href"]
const _hoisted_54 = ["href"]
const _hoisted_55 = { class: "entry-meta" }
const _hoisted_56 = { href: "#" }
const _hoisted_57 = { class: "entry-content" }
const _hoisted_58 = { class: "col-lg-5" }
const _hoisted_59 = { class: "row posts-md col-mb-30" }
const _hoisted_60 = { class: "grid-inner row gutter-20" }
const _hoisted_61 = { class: "col-md-4" }
const _hoisted_62 = ["href"]
const _hoisted_63 = ["src"]
const _hoisted_64 = { class: "col-md-8" }
const _hoisted_65 = { class: "entry-title title-xs" }
const _hoisted_66 = { class: "entry-categories" }
const _hoisted_67 = ["href"]
const _hoisted_68 = ["href"]
const _hoisted_69 = { class: "entry-meta" }
const _hoisted_70 = { href: "#" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isApiCallInProgress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-7 mb-5 mb-lg-0" }, [
                  _createElementVNode("div", {
                    class: "loading-placeholder",
                    style: {"background-color":"#e0e0e0","aspect-ratio":"16/9"}
                  }),
                  _createElementVNode("div", {
                    class: "loading-placeholder",
                    style: {"height":"2em","width":"60%","background-color":"#e0e0e0","margin-top":"1em"}
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_5, [
                  _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "font-body fw-medium mb-4 h4" }, "Recent Posts", -1)),
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (i) => {
                      return _createElementVNode("article", {
                        class: "entry col-12",
                        key: i
                      }, _cache[0] || (_cache[0] = [
                        _createStaticVNode("<div class=\"grid-inner row gutter-20\" data-v-9e0803ce><div class=\"col-md-4\" data-v-9e0803ce><a class=\"entry-image\" data-v-9e0803ce><div class=\"loading-placeholder\" style=\"background-color:#e0e0e0;aspect-ratio:16/9;\" data-v-9e0803ce></div></a></div><div class=\"col-md-8\" data-v-9e0803ce><div class=\"entry-title title-xs\" data-v-9e0803ce><div class=\"entry-categories\" data-v-9e0803ce><div class=\"loading-placeholder\" style=\"height:1.2em;width:80%;background-color:#e0e0e0;margin-bottom:1em;\" data-v-9e0803ce></div></div><h3 data-v-9e0803ce><div class=\"loading-placeholder\" style=\"height:2em;width:100%;background-color:#e0e0e0;margin-bottom:1em;\" data-v-9e0803ce></div></h3></div><div class=\"entry-meta\" data-v-9e0803ce><ul data-v-9e0803ce><li data-v-9e0803ce><a href=\"#\" data-v-9e0803ce><div class=\"loading-placeholder\" style=\"height:1.2em;width:60%;background-color:#e0e0e0;\" data-v-9e0803ce></div></a></li></ul></div></div></div>", 1)
                      ]))
                    }), 64))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("article", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("a", {
                        href: "/post/" + encodeURIComponent(_ctx.recentPosts[0]?.attributes.slug)
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.getLargestMediaUrl(_ctx.recentPosts[0]?.attributes.thumbnail.data),
                          loading: "lazy",
                          alt: "Image 3",
                          class: "image-preview"
                        }, null, 8, _hoisted_15)
                      ], 8, _hoisted_14)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("a", {
                          href: "/post/category/" + _ctx.recentPosts[0]?.attributes.category.data.attributes.name
                        }, _toDisplayString(_ctx.recentPosts[0]?.attributes.category.data.attributes.name), 9, _hoisted_18)
                      ]),
                      _createElementVNode("h3", null, [
                        _createElementVNode("a", {
                          href: "/post/" + encodeURIComponent(_ctx.recentPosts[0]?.attributes.slug),
                          class: "stretched-link color-underline"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.recentPosts[0]?.attributes.title), 1)
                        ], 8, _hoisted_19)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.convertTimeToDate(_ctx.recentPosts[0]?.attributes.createdAt)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.recentPosts[0]?.attributes.description), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "font-body fw-medium mb-4 h4" }, "Recent Posts", -1)),
                  _createElementVNode("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentPosts.slice(1, 5), (post) => {
                      return (_openBlock(), _createElementBlock("article", {
                        class: "entry col-12",
                        key: post.id
                      }, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("a", {
                              class: "entry-image",
                              href: "/post/" + encodeURIComponent(post.attributes.slug)
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.getLargestMediaUrl(post.attributes.thumbnail.data),
                                alt: "Image"
                              }, null, 8, _hoisted_28)
                            ], 8, _hoisted_27)
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("a", {
                                  href: "/post/category/" + post.attributes.category.data.attributes.name
                                }, _toDisplayString(post.attributes.category.data.attributes.name), 9, _hoisted_32)
                              ]),
                              _createElementVNode("h3", null, [
                                _createElementVNode("a", {
                                  href: "/post/" + encodeURIComponent(post.attributes.slug),
                                  class: "stretched-link color-underline"
                                }, _toDisplayString(post.attributes.title), 9, _hoisted_33)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", _hoisted_35, _toDisplayString(_ctx.convertTimeToDate(post.attributes.createdAt)), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])),
    (_ctx.isApiCallInProgress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "font-body fw-medium" }, "Popular", -1)),
              _createElementVNode("div", _hoisted_39, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-lg-7 mb-5 mb-lg-0" }, [
                  _createElementVNode("div", {
                    class: "loading-placeholder",
                    style: {"background-color":"#e0e0e0","aspect-ratio":"16/9"}
                  }),
                  _createElementVNode("div", {
                    class: "loading-placeholder",
                    style: {"height":"2em","width":"60%","background-color":"#e0e0e0","margin-top":"1em"}
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_40, [
                  _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "font-body fw-medium mb-4 h4" }, "Highlights", -1)),
                  _createElementVNode("div", _hoisted_41, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (i) => {
                      return _createElementVNode("article", {
                        class: "entry col-12",
                        key: i
                      }, _cache[4] || (_cache[4] = [
                        _createStaticVNode("<div class=\"grid-inner row gutter-20\" data-v-9e0803ce><div class=\"col-md-4\" data-v-9e0803ce><a class=\"entry-image\" data-v-9e0803ce><div class=\"loading-placeholder\" style=\"background-color:#e0e0e0;aspect-ratio:16/9;\" data-v-9e0803ce></div></a></div><div class=\"col-md-8\" data-v-9e0803ce><div class=\"entry-title title-xs\" data-v-9e0803ce><div class=\"entry-categories\" data-v-9e0803ce><div class=\"loading-placeholder\" style=\"height:1.2em;width:80%;background-color:#e0e0e0;margin-bottom:1em;\" data-v-9e0803ce></div></div><h3 data-v-9e0803ce><div class=\"loading-placeholder\" style=\"height:2em;width:100%;background-color:#e0e0e0;margin-bottom:1em;\" data-v-9e0803ce></div></h3></div><div class=\"entry-meta\" data-v-9e0803ce><ul data-v-9e0803ce><li data-v-9e0803ce><a href=\"#\" data-v-9e0803ce><div class=\"loading-placeholder\" style=\"height:1.2em;width:60%;background-color:#e0e0e0;\" data-v-9e0803ce></div></a></li></ul></div></div></div>", 1)
                      ]))
                    }), 64))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "font-body fw-medium" }, "Popular", -1)),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("article", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("a", {
                        href: "/post/" + encodeURIComponent(_ctx.popularPosts[0]?.attributes.slug)
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.getLargestMediaUrl(_ctx.popularPosts[0]?.attributes.thumbnail.data),
                          loading: "lazy",
                          alt: "Image 3",
                          class: "image-preview"
                        }, null, 8, _hoisted_50)
                      ], 8, _hoisted_49)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("a", {
                          href: "/post/category/" + _ctx.popularPosts[0]?.attributes.category.data.attributes.name
                        }, _toDisplayString(_ctx.popularPosts[0]?.attributes.category.data.attributes.name), 9, _hoisted_53)
                      ]),
                      _createElementVNode("h3", null, [
                        _createElementVNode("a", {
                          href: "/post/" + encodeURIComponent(_ctx.popularPosts[0]?.attributes.slug),
                          class: "stretched-link color-underline"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.popularPosts[0]?.attributes.title), 1)
                        ], 8, _hoisted_54)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", _hoisted_56, _toDisplayString(_ctx.convertTimeToDate(_ctx.popularPosts[0]?.attributes.createdAt)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.popularPosts[0]?.attributes.description), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "font-body fw-medium mb-4 h4" }, "Highlights", -1)),
                  _createElementVNode("div", _hoisted_59, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popularPosts.slice(1, 5), (post) => {
                      return (_openBlock(), _createElementBlock("article", {
                        class: "entry col-12",
                        key: post.id
                      }, [
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("a", {
                              class: "entry-image",
                              href: "/post/" + encodeURIComponent(post.attributes.slug)
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.getLargestMediaUrl(post.attributes.thumbnail.data),
                                alt: "Image"
                              }, null, 8, _hoisted_63)
                            ], 8, _hoisted_62)
                          ]),
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("div", _hoisted_66, [
                                _createElementVNode("a", {
                                  href: "/post/category/" + post.attributes.category.data.attributes.name
                                }, _toDisplayString(post.attributes.category.data.attributes.name), 9, _hoisted_67)
                              ]),
                              _createElementVNode("h3", null, [
                                _createElementVNode("a", {
                                  href: "/post/" + encodeURIComponent(post.attributes.slug),
                                  class: "stretched-link color-underline"
                                }, _toDisplayString(post.attributes.title), 9, _hoisted_68)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", _hoisted_70, _toDisplayString(_ctx.convertTimeToDate(post.attributes.createdAt)), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])),
    _cache[10] || (_cache[10] = _createStaticVNode("<div id=\"content\" class=\"section bg-transparent my-0 py-0\" data-v-9e0803ce><div class=\"content-wrap pt-5\" style=\"overflow:visible;\" data-v-9e0803ce><div class=\"container\" data-v-9e0803ce><div class=\"content-wrap\" data-v-9e0803ce><div class=\"container mw-lg py-lg-5\" data-v-9e0803ce><div class=\"text-center mb-5 mb-lg-6\" data-v-9e0803ce><h2 class=\"display-5\" data-v-9e0803ce>Want To Get Involved?</h2></div><div class=\"clear\" data-v-9e0803ce></div><div class=\"row grid-border justify-content-center mt-3\" data-v-9e0803ce><div class=\"col-lg-4 col-padding py-lg-0\" data-v-9e0803ce><h3 class=\"mb-1 fw-semibold\" data-v-9e0803ce>Become an Author</h3><p class=\"mb-5\" data-v-9e0803ce>Have something insightful, funny, or thought-provoking to share? Join our community of writers and publish your own articles.</p><div class=\"row flex-column gy-1 list-link\" data-v-9e0803ce><a href=\"/about#contact\" class=\"fw-medium link-dark h-text-primary\" data-v-9e0803ce><u data-v-9e0803ce>Submit Post</u></a></div></div><div class=\"col-lg-4 col-padding py-lg-0\" data-v-9e0803ce><h3 class=\"mb-1 fw-semibold\" data-v-9e0803ce>Community</h3><p class=\"mb-5\" data-v-9e0803ce>Engage with like-minded developers, share experiences, and contribute to discussions about whatever.</p><div class=\"row flex-column gy-1 list-link\" data-v-9e0803ce><a href=\"/community\" class=\"mb-2 fw-medium link-dark h-text-primary\" data-v-9e0803ce><u data-v-9e0803ce>Join the Community</u></a></div></div><div class=\"col-lg-4 col-padding py-lg-0\" data-v-9e0803ce><h3 class=\"mb-1 fw-semibold\" data-v-9e0803ce>Contact Us</h3><p class=\"mb-5\" data-v-9e0803ce>Have questions or feedback? Reach out to us—we’d love to hear from you!</p><div class=\"row flex-column gy-1 list-link\" data-v-9e0803ce><a href=\"/about#contact\" class=\"mb-2 fw-medium link-dark h-text-primary\" data-v-9e0803ce><u data-v-9e0803ce>Contact Us</u></a><a href=\"/about#contact\" class=\"mb-2 fw-medium link-dark h-text-primary\" data-v-9e0803ce><u data-v-9e0803ce>Report Content</u></a></div></div></div></div></div></div></div></div><div id=\"content\" class=\"section bg-transparent my-0 py-0\" data-v-9e0803ce><div class=\"content-wrap pt-5\" data-v-9e0803ce><div class=\"container\" data-v-9e0803ce><div class=\"container-fluid\" data-v-9e0803ce><div class=\"row justify-content-center mx-auto mw-md gx-5\" data-v-9e0803ce><div class=\"col\" data-v-9e0803ce><p class=\"h6 mb-0\" data-v-9e0803ce> This site and its community are designed for entertainment and engagement. While we strive for accuracy in our content, occasional errors may occur, and community contributions reflect individual opinions, not the views of the site. If you have inquiries, wish to rectify misinformation, or seek clarification about our community, feel free to <a href=\"/about#contact\" data-v-9e0803ce>Contact Us</a>. </p></div></div></div></div></div></div>", 2))
  ], 64))
}